import { MaterialIcons } from "@expo/vector-icons";
import {
	Button,
	FormControl,
	Icon,
	Input,
	ScrollView,
	Stack,
} from "native-base";
import React, { useState } from "react";
import { View } from "react-native";
import forgotPasswordPost from "../../common/forgotPasswordPost";
import ErrorToast from "../../components/ErrorToast";
import InfoToast from "../../components/InfoToast";
import PasswordReset from "./PasswordReset";

const ForgotPassword = ({ setIsLogin }) => {
	const [identity, setIdentity] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [memberGuid, setMemberGuid] = useState("");
	const [isOTP, setIsOTP] = useState(false);

	const handleUserIdentitySubmit = async () => {
		try {
			setIsSubmitting(true);
			let user = await forgotPasswordPost(identity);

			if (user.data.result) {
				setIsSubmitting(false);
				setIsOTP(true);
				setMemberGuid(user.data.storemember_guid);
				InfoToast("Member found");
			}
		} catch (error) {
			setIsSubmitting(false);
			if (error.data?.error) {
				ErrorToast(error.data.error, "Forgot Password");
			} else {
				ErrorToast(error.message, "Forgot Password");
			}
		}
	};

	return (
		<View style={{ marginTop: 50 }}>
			<ScrollView>
				{isOTP ? (
					<PasswordReset
						setIsOTP={setIsOTP}
						setIsLogin={setIsLogin}
						memberGuid={memberGuid}
					/>
				) : (
					<Stack space={2.5}>
						<View>
							<FormControl.Label>
								Please enter your registered ID or Passport Number
							</FormControl.Label>
							<Input
								InputLeftElement={
									<Icon
										as={<MaterialIcons name={"person"} />}
										size={5}
										ml="2"
										color="muted.400"
									/>
								}
								placeholder={`ID or Passport Number`}
								label={`ID or Passport Number`}
								value={identity}
								onChangeText={(text) => setIdentity(text)}
							/>
						</View>
						<View
							style={{ flexDirection: "row", justifyContent: "space-between" }}
						>
							<Button onPress={() => setIsLogin(true)} variant="subtle">
								Cancel
							</Button>
							<Button
								onPress={() => handleUserIdentitySubmit()}
								isLoading={isSubmitting}
								isLoadingText="Submitting"
								variant={isSubmitting ? "outline" : "solid"}
							>
								Submit
							</Button>
						</View>
					</Stack>
				)}
			</ScrollView>
		</View>
	);
};

export default ForgotPassword;
